import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Avatar } from '../Avatar';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { useListContext } from './ListContext';
export const ListItem = forwardRef(function ListItem(props, ref) {
    const { icon: listIcon, iconColor: listIconColor, avatar, } = useListContext();
    const { children, className, icon = listIcon, iconColor = listIconColor, label, ...rest } = props;
    const renderIcon = icon && (React.createElement(Icon, { size: "small", src: icon, color: iconColor }));
    return (React.createElement("li", { ...rest, className: clsx('mollie-ui-list-item', {
            'mollie-ui-list-item--icon': !!icon,
            'mollie-ui-list-item--avatar': !!avatar,
        }, className), ref: ref },
        avatar ? (React.createElement(Avatar, { size: "large", variant: "action", backgroundColor: "tertiary" }, renderIcon)) : (renderIcon),
        React.createElement("div", { className: "mollie-ui-list-item-content" },
            label && (React.createElement(Text, { variant: "subtitle-medium", className: "mollie-ui-list-item-label" }, label)),
            React.createElement("div", { className: "mollie-ui-list-item-description" }, children))));
});
ListItem.displayName = 'List.Item';
//# sourceMappingURL=ListItem.js.map